






















import Vue from 'vue';

export default Vue.extend({
  computed: {
    widthSpecificClasses(): string {
      return this.$vuetify.breakpoint.mdAndUp
        ? 'bottom-bar-no-top-nav'
        : 'bottom-bar-with-top-nav';
    }
  }
});
